
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  private currentLanguageSubject = new BehaviorSubject<string>('vi');
  public currentLanguage$ = this.currentLanguageSubject.asObservable();

  private supportedLanguages = ['vi', 'en', 'zh', 'fr'];

  constructor(private translate: TranslateService) {
    this.initializeLanguage();
  }

  private initializeLanguage(): void {
    const savedLang = localStorage.getItem('selectedLanguage');
    const browserLang = this.translate.getBrowserLang();
    
    let defaultLang = 'vi';
    
    if (savedLang && this.supportedLanguages.includes(savedLang)) {
      defaultLang = savedLang;
    } else if (browserLang && this.supportedLanguages.includes(browserLang)) {
      defaultLang = browserLang;
    }
    
    this.setLanguage(defaultLang);
  }

  getCurrentLanguage(): string {
    return this.currentLanguageSubject.value;
  }

  setLanguage(language: string): void {
    if (this.supportedLanguages.includes(language)) {
      this.translate.use(language);
      this.currentLanguageSubject.next(language);
      localStorage.setItem('selectedLanguage', language);
      
      
      document.documentElement.lang = language;
    }
  }

  switchLanguage(language: string): void {
    this.setLanguage(language);
  }

  getSupportedLanguages(): string[] {
    return this.supportedLanguages;
  }

  resetToDefault(): void {
    this.setLanguage('vi');
  }
}